import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=23f78bea&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=23f78bea&prod&scoped=true&lang=css"
import style1 from "./Order.vue?vue&type=style&index=1&id=23f78bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f78bea",
  null
  
)

export default component.exports